export { FxLayoutBasicSideComponent } from './basic-side/basic-side.component';
export { FxLayoutDefaultComponent } from './layout-default/layout-default.component';
export { FxLayoutModule } from './layout.module';
